export default __webpack_public_path__ + "static/media/Hurricanes.67226277.png";